import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';
import * as moment from 'moment';
@Component({
    selector: 'app-daily-attendance-staff',
    templateUrl: './daily-attendance-staff.component.html',
    styleUrls: ['./daily-attendance-staff.component.css']
})
export class DailyAttendanceStaffComponent implements OnInit {
    Submitted: boolean = false;
    EmployeeCategoryList = [];
    dt: any = new Date();
    StaffAttendanceView: any;
    StaffAttendanceList = [];


    LeaveTypeList = [];

    constructor(private payrollService: HrService, private lookupservice: LookupService, public globalHelper: GlobalHelper,
        private spinnerService: Ng4LoadingSpinnerService) { }

    DailyAttendanceModel = {
        EmployeeCategoryID: 0,
        PrimaryDepartmentID: 0,
        DesignationID: 0,
        StaffIdentity: '',
        AttendanceDate: moment(new Date()).format("DD-MMM-YYYY"),
    }

    ClearSearch() {
        this.DailyAttendanceModel.AttendanceDate = moment(new Date()).format("DD-MMM-YYYY");
        this.DailyAttendanceModel.EmployeeCategoryID = 0;
        this.DailyAttendanceModel.PrimaryDepartmentID = 0;
        this.DailyAttendanceModel.DesignationID = 0;
        this.DailyAttendanceModel.StaffIdentity = '';
        this.StaffAttendanceList = [];

    }

    DateAlert = '';

    DateValidation() {
        if (new Date(this.DailyAttendanceModel.AttendanceDate) > this.dt.setDate(this.dt.getDate()) || this.DailyAttendanceModel.AttendanceDate == null || this.DailyAttendanceModel.AttendanceDate == '') {
            this.DateAlert = 'Please Select A Date Less Than Current Date.';
            return false;
        }
        return true;
    }


    FieldValidation() {
        return this.DailyAttendanceModel.AttendanceDate == null || this.DailyAttendanceModel.AttendanceDate == '';
    }


    GetStaffDailyAttendance() {
        this.Submitted = true;
        if (!this.FieldValidation()) {
            this.spinnerService.show();
            this.DailyAttendanceModel.AttendanceDate = this.DailyAttendanceModel.AttendanceDate != null && this.DailyAttendanceModel.AttendanceDate != '' ? moment(this.DailyAttendanceModel.AttendanceDate).format('DD-MMM-YYYY') : '';
            this.payrollService.GetStaffDailyAttendance(JSON.stringify(this.DailyAttendanceModel)).subscribe((data: any) => {
                this.StaffAttendanceView = data.StaffAttendanceView;
                this.StaffAttendanceList = this.StaffAttendanceView.StaffAttendanceList
                this.globalHelper.CheckActionStatus(data);
                this.DateAlert = '';
                this.spinnerService.hide();

            });
        }
    };
    getDataDiff(startDate, endDate, TotalWorkingHour) {
        let d2: Date = new Date(startDate);
        let d1 = Date.parse(endDate); //time in milliseconds
        var timeDiff = d2.getTime() - d1;
        var diff = timeDiff / (1000 * 3600 * 24);
        return Math.floor(diff);
    }



    SaveStaffDailyAttendance() {
        var item = {
            EmployeeCategoryID: this.DailyAttendanceModel.EmployeeCategoryID,
            AttendanceDate: this.DailyAttendanceModel.AttendanceDate != null ? moment(this.DailyAttendanceModel.AttendanceDate).format('DD-MMM-YYYY') : ''

        }
        this.spinnerService.show();
        this.payrollService.SaveStaffDailyAttendance(JSON.stringify(item), JSON.stringify(this.StaffAttendanceView.StaffAttendanceList)).subscribe((data: any) => {
            this.spinnerService.hide();
            this.globalHelper.CheckActionStatus(data);
            this.GetStaffDailyAttendance();

        });
    };



    ngOnInit() {
        this.GetDepartment();
        this.GetDesignation();
        this.GetEmployeeCategory();
        this.GetLeaveType();
    }

    GetEmployeeCategory() {
        this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
            this.EmployeeCategoryList = data.LookupItems;

        });
    };
    ListDepartment = []
    GetDepartment() {
        this.lookupservice.GetLookupsList('Department', '').subscribe((data: any) => {
            this.ListDepartment = data.LookupItems;
        });

    }

    DesignationList = []
    GetDesignation() {
        this.lookupservice.GetLookupsList('Designation', '').subscribe((data: any) => {
            this.DesignationList = data.LookupItems;
        });
    };

    GetLeaveType() {
        this.lookupservice.GetLookupsList('LeaveType', '').subscribe((data: any) => {
            this.LeaveTypeList = data.LookupItems;
            this.LeaveTypeList.splice(0, 1);
        });
    };

    // Download

    FilePath: any
    DailyAttendanceDownload() {
        this.Submitted = true;
        if (!this.FieldValidation()) {
            this.spinnerService.show();
            this.DailyAttendanceModel.AttendanceDate = this.DailyAttendanceModel.AttendanceDate != null && this.DailyAttendanceModel.AttendanceDate != '' ? moment(this.DailyAttendanceModel.AttendanceDate).format('DD-MMM-YYYY') : '';
            this.payrollService.DailyAttendanceDownload(JSON.stringify(this.DailyAttendanceModel)).subscribe((data: any) => {
                this.spinnerService.hide();
                this.Submitted = false;
                this.FilePath = data.FilePath;
                if (data.webResponse != null)
                    if (data.FilePath != null)
                        window.location = data.FilePath;

            });
        }

    };

    // Print


    DailyAttendancePrint() {
        this.Submitted = true;
        if (!this.FieldValidation()) {
            this.spinnerService.show();
            var url = "DailyAttendancePrint?EmployeeCategoryID" + this.DailyAttendanceModel.EmployeeCategoryID + '&PrimaryDepartmentID=' + this.DailyAttendanceModel.PrimaryDepartmentID + '&DesignationID=' + this.DailyAttendanceModel.DesignationID + '&StaffIdentity=' + this.DailyAttendanceModel.StaffIdentity + '&AttendanceDate=' + this.DailyAttendanceModel.AttendanceDate;
            this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
            this.spinnerService.hide();
            this.Submitted = false;
        };
    }

    

}
